import { render } from "./DialogBlockDay.vue?vue&type=template&id=03ffd85d"
import script from "./DialogBlockDay.vue?vue&type=script&lang=js"
export * from "./DialogBlockDay.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__